import { z } from 'zod';

export enum RefGroupTypeEnum {
  Org = 1,
  Demo = 2,
};
export const RefGroupType = z.nativeEnum(RefGroupTypeEnum);
export type RefGroupType = z.infer<typeof RefGroupType>;